import { ROLE_ADMINISTRATOR } from '../constants/roles';
import { PERMISSION_ADD_NEWBORN } from '../constants/permissions';

export default {
  [ROLE_ADMINISTRATOR]: [PERMISSION_ADD_NEWBORN],
};
